import { type ReactNode } from 'react'

type FormFieldProps = {
  children: ReactNode
  className?: string
  label: string
}

export const FormField = ({ children, className, label }: FormFieldProps) => (
  <label className={['form-group', className].filter(Boolean).join(' ')}>
    <span className="form-label">{label}</span>
    {children}
  </label>
)
